// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2-ihk","containerItemsCenter":"Skeleton_containerItemsCenter__2ma3u"};